import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Status } from '../configs/status';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class LicenceService {
  LICENCE_PATH = `/licences`;

  constructor(private http: HttpService) {}

  getLicences(params: object = {}): Observable<any> {
    return this.http.get(`${this.LICENCE_PATH}`, params);
  }

  postLicences(body: object = {}): Observable<any> {
    return this.http.post(`${this.LICENCE_PATH}`, body);
  }

  getLicenceById(id, params: object = {}): Observable<any> {
    return this.http.get(`${this.LICENCE_PATH}/${id}`, params);
  }

  patchLicence(id, body: object = {}): Observable<any> {
    return this.http.patch(`${this.LICENCE_PATH}/${id}`, body);
  }

  deleteLicence(id): Observable<any> {
    return this.http.delete(`${this.LICENCE_PATH}/${id}`);
  }

}
